import CheckoutPayment from './CheckoutPayment.component';

export default CheckoutPayment;